import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module19Nav = () => {
  const { module19 } = useSelector((state) => state.module19, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module19Images/JourneyMap19-01.png';
    const mobileImage =
      '/Module19Images/JourneyMap19-01_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module19Images/Unit4_Mod4BG_No_Fences.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module9Images/Module9NavImages/JourneyMap_Mod4_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module9Images/Module9NavImages/JourneyMap_Mod4_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/selfadvocacy',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/self_advocacy/self_advocacy_instrumental.m4a',
    slides: [
      `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
      'appfiles/self_advocacy/practice_birdshow_greet.mp4',
      `userfiles/${module19.StudentID}/self_advocacy_practice_greet_5.mp4`,
      'appfiles/self_advocacy/practice_birdshow_answer.mp4',
      `userfiles/${module19.StudentID}/self_advocacy_practice_close_5.mp4`,
      `influencers/${login.influencerid3}/conversation_affirmation.mp4`,
      `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_6.mp4`,
      `influencers/${login.influencerid1}/respond_affirmation.mp4`,
      `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/respond_video_message.mp4`,
      `userfiles/${module19.StudentID}/self_advocacy_celebration_surprise_8.mp4`,
      `influencers/${login.influencerid3}/respond_affirmation.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE19'
          module={module19}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit4'
          nextDestiny='/unit4'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={4}
          animal={MediaService.getImage('/Images/Button_monkeyHead.png', login)}
        />
      )}
    </>
  );
};
export default Module19Nav;
